import { ulid } from 'ulid';
import API from './API';

export default class UploadManager {

    _complete = {};
    _uploads = {};

    clearBatch = (batch) => {
        this._complete[batch] = {};
        this._uploads[batch] = {};
    }

    uploads = (batch) => {
        if (this._uploads[batch] === undefined) {
            return [];
        }
        return Object.values(this._uploads[batch])
    }

    complete = (batch) => {
        if (this._complete[batch] === undefined) {
            return [];
        }
        return Object.values(this._complete[batch])
    }

    removeUpload = (batch, assetId) => {
        delete this._complete[batch][assetId];
        delete this._uploads[batch][assetId];
    }

    newUpload = (batch, file, assetId, tags, onUploadProgress, onUploadComplete, dimensions) => {
        this._uploads[batch][assetId] = {
            assetId: assetId,
            url: null,
            filename: file.name,
            tags: tags,
            progress: 0,
            dimensions: dimensions
        };

        this.uploadAsset(file, (progress) => this.saveProgress(batch, assetId, progress, onUploadProgress))
            .then(url => {

                API.post('/assets', {
                    assetId: assetId,
                    url: url,
                    filename: file.name,
                    tags: tags,
                    dimensions: dimensions
                }).then(() => {
                    this.finishUpload(batch, assetId, onUploadComplete)
                }).catch(errors => {
                    console.error(errors);
                    this.removeUpload(batch, assetId);
                    onUploadComplete(false, assetId);
                    alert(errors[0].detail ?? 'Sorry, there was an error uploading your file');
                });

            }).catch(err => {
                onUploadComplete(false, assetId);
                console.error('errrrr', err)
                alert('Sorry, there was a error uploading your file');
            })
    }

    uploadAsset(inputFile, callback) {
        return new Promise((resolve, reject) => {
            const extraRand = Math.round(Math.random() * Number.MAX_SAFE_INTEGER).toString(36);
            const url = 'https://uploads.getsoapy.com/tmp/' + ulid() + '/' + extraRand;

            var xhr = new XMLHttpRequest();
            xhr.upload.addEventListener('progress', (e) => {
                callback(Math.round(e.loaded / e.total * 100))
            }, false);
            xhr.addEventListener('load', (e) => resolve(url), false);
            xhr.addEventListener('error', (e) => reject(e), false);
            xhr.addEventListener('abort', (e) => reject(e), false);
            xhr.open('PUT', url);

            xhr.send(inputFile);
        });
    }

    saveProgress = (batch, assetId, progress, onUploadProgress) => {
        this._uploads[batch][assetId].progress = progress;

        if (onUploadProgress) {
            onUploadProgress(progress)
        }
    }

    finishUpload = (batch, assetId, onUploadComplete) => {
        API.get('/assets?assetIds[]=' + assetId).then(result => {
            this._complete[batch][assetId] = this._uploads[batch][assetId];
            this._complete[batch][assetId].thumbnail = result[0].thumbnail;

            delete this._uploads[batch][assetId];

            onUploadComplete(this._complete[batch][assetId]);
        }).catch(errors => {
            console.error(errors);
            alert(errors[0].detail ?? 'Sorry, there was an error uploading your file');
            onUploadComplete(false);
        })
    }
}
